const initialState = {
    isLoading: false,
    showPopup: false,
    status: null
}

export function projectNotFoundReducer(state = initialState, action) {
    switch (action.type) {
        case 'PROJECT_NOT_FOUND_SUCCESS':
            return {
                isLoading: false,
                showPopup: true,
                status: action.payload.status
            }
        case 'RESET_PROJECT_NOT_FOUND':
            return {
                isLoading: false,
                showPopup: false,
                status: null
            }
        default:
            return state
    }
}

export default projectNotFoundReducer
